import * as React from "react";
import { CheckboxEditor } from "../../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { ClientRecordAction } from "../../Action/ClientRecordAction";
import { RegulatoryTabs } from "../../Resource/RegulatoryContents";
import { SectionTable } from "../SectionTable";

interface IHighValueSectionProps {
    customerid: number;
    hasReadWriteAccess: boolean;
}
interface IHighValueSectionState {
    data: boolean;
    isLoading: boolean;
}

export class HighValueSection extends FormComponent<IHighValueSectionProps, IHighValueSectionState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: false,
        };
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        this.setState({ isLoading: true });
        ClientRecordAction.getHighValue(this.props.customerid, (val) => {
            this.setState({
                data: val,
                isLoading: false,
            });
        });
    }

    render() {
        const { data, isLoading } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={true} />;
        }
        const columnConfigs = [{ title: "High value", data: data ? "Yes" : "No" }];
        return (
            <SectionTable
                sectionHeader={RegulatoryTabs.HighValue}
                columnConfigs={columnConfigs}
                lightboxContent={(data, onDataChange) => this.renderLightBox(data, onDataChange)}
                onSave={(data) => this.onSave(data?.HighValueFlag)}
                data={data}
                canEdit={this.props?.hasReadWriteAccess == true}
            />
        );
    }

    renderLightBox(data: boolean, onDataChange): JSX.Element {
        return (
            <>
                <CheckboxEditor
                    value={data}
                    cssWrapper="control-size-60 square-checkbox"
                    label={"High value"}
                    onChange={(v) => {
                        onDataChange({ HighValueFlag: v });
                    }}
                />
            </>
        );
    }

    onSave(item: boolean): boolean {
        if (this.isValid()) {
            this.saveData(item);
            return true;
        }
        return false;
    }

    saveData(data: boolean) {
        ClientRecordAction.putHighValue(this.props.customerid, data, () => {
            this.getData();
        });
    }
}
